<template>
<div>
    <Breadcrumbs main="CRM" title="Leads" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Lead</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="selectedOwner || selectedStage || selectedStatus || selectedSource || selectedLabel || filter || selectedClosureStatus">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                   
                                    <div class="grid-item">
                                        <b-form-group label="Owner" label-for="owner-name">
                                            <b-form-select id="owner-name" v-model="selectedOwner" :options="ownerOptions">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Owner
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>

                                    <div class="grid-item">
                                        <b-form-group label="Stage" label-for="stage-name">
                                            <b-form-select id="stage-name" v-model="selectedStage" :options="stage_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Stage
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-group label="Status" label-for="status">
                                            <b-form-select id="status" v-model="selectedStatus" :options="status_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Status
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-group label="Source" label-for="source-name">
                                            <b-form-select id="source-name" v-model="selectedSource" :options="source_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Source
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-group label="Source" label-for="closure-name">
                                            <b-form-select id="closure-name" v-model="selectedClosureStatus" :options="closure_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Closure Status
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="lead-container" style="margin-top: 22px;">
                            <div class="table-width">
                                <div v-if="!loading && !error">
                                    <div class="table-responsive datatable-vue">
                                        <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered">
                                            <template #cell(index)="data">
                                                {{ (currentPage - 1) * perPage + data.index + 1 }}
                                            </template>
                                            <template #cell(name)="data">
                                                <router-link :to="{ name: 'LeadDetails', params: { id: data.item.id } }" class="text-decoration-none">
                                                    <div class="d-flex flex-column">
                                                        <h7 style="font-weight: 600;">{{ data.item.first_name }} {{ data.item.last_name }}</h7>
                                                        <small>{{data.item.phone}}</small>
                                                        <small>{{data.item.email}}</small>
                                                    </div>
                                                </router-link>

                                                <span style="display: flex; flex-direction: column; gap: 8px;" v-if="data.item?.company">
                                                    <small><span style="font-size: medium;">
                                                            <b-badge pill variant="primary">{{ data.item?.company?.name }}</b-badge>
                                                        </span></small>
                                                    <small>{{ data.item?.company?.address }}</small>
                                                </span>
                                            </template>

                                        

                                            <template #cell(trigger)="data">
                                                <div class="d-flex flex-column">
                                                    <h7 class="text-capitalize" v-if="data.item.source">{{data.item.source}}</h7>
                                                    <small v-if="data.item.trigger_event">{{data.item.trigger_event }}</small>
                                                </div>
                                            </template>
                                            <template #cell(stage)="data">
                                                <span
                                                    class="stage-badge"
                                                    :class="`stage-${data.item.stage}`"
                                                >
                                                    {{
                                                        stage_list.find(
                                                            item => item.value === data.item.stage
                                                        )?.text
                                                    }}
                                                </span>
                                            </template>
                                            <template #cell(status)="data">
                                                <span class="badge" @click="getStatus(data.item.status, data.item.id)" :class="{
                                                            'badge-primary': data.item.status === 'open',
                                                            'badge-success': data.item.status === 'active',
                                                            'badge-info': data.item.status === 'hold',
                                                            'badge-secondary': data.item.status === 'rejected',
                                                            'badge-light': data.item.status === 'lost',
                                                            'badge-info': data.item.status === 'converted'
                                                        }" v-b-modal.modal-status-change>
                                                    {{
                                                            status_list.find(
                                                                item => item.value === data.item.status
                                                            )?.text
                                                        }}
                                                </span>
                                            </template>
                                            <template #cell(label)="data">
                                                <div v-if="data.item.label && data.item.label.length > 0" @click="addLabeltoLead(data.item)" v-b-modal.modal-prevent-closing-label>
                                                    <div v-for="label in data.item.label" :key="label.id">

                                                        <b-badge pill variant="success">{{ label?.name }}</b-badge>
                                                    </div>
                                                </div>
                                                <div v-else v-b-modal.modal-prevent-closing-label @click="addLabeltoLead(data.item)">
                                                    <b-badge pill variant="secondary">Add Label</b-badge>
                                                </div>
                                            </template>

                                            <template #cell(owner)="data">
                                                <h7 v-if=" data.item.owner">{{ data.item.owner?.full_name }}</h7>
                                            </template>

                                            <template #cell(value)="data">
                                                <h7 v-if=" data.item.pipeline_value">{{ data.item.pipeline_value}}</h7>
                                            </template>

                                            <template #cell(next_followup)="data">
                                                <h7 v-if=" data.item.next_followup"> {{ formatDateTime(data.item.next_followup) }}</h7>
                                            </template>

                                            <!-- value
                                             -->

                                            <!-- 
                                            <template #cell(contacted)="row">
                                                <span v-if="row.value == true">
                                                    <b-badge variant="success">Yes</b-badge>
                                                </span>
                                                <span v-if="row.value == false ">
                                                    <b-badge variant="danger">No</b-badge>
                                                </span>
                                            </template> -->

                                            <template #cell(action)="data">
                                                <span style="display: flex; gap: 12px;">
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteLead(data.item.id)" title="Delete"></feather>
                                                    <feather @click="editItem(data.item)" type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </span>
                                            </template>
                                        </b-table>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="loader-box">
                                        <div class="loader-10"></div>
                                    </div>
                                </div>

                                <b-col class="my-1 p-0">
                                    <b-row class="mt-3">
                                        <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                            <span>
                                                <!-- First Page Button (<<) -->
                                                <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                                    <b-icon icon="chevron-double-left"></b-icon>
                                                </button>

                                                <!-- Previous Page Button (<) -->

                                                <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                                    <b-icon icon="chevron-left"></b-icon>
                                                </button>
                                            </span>

                                            <span class="align-self-center">
                                                <span class="align-self-center">
                                                    <span class="d-flex align-items-center" style="gap: 6px;">
                                                        <span>Page</span>
                                                        <b-form-input v-model="pageInput" style="box-shadow: none; max-width: 40px;" @input="handlePageInput" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1" :max="totalPages"></b-form-input>
                                                        <span>of {{ totalPages }}</span>
                                                    </span>
                                                </span>
                                            </span>

                                            <span>
                                                <!-- Next Page Button (>) -->
                                                <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                                    <b-icon icon="chevron-right"></b-icon>
                                                </button>

                                                <!-- Last Page Button (>>) -->
                                                <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                                    <b-icon icon="chevron-double-right"></b-icon>
                                                </button>
                                            </span>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </div>

                            <div class="label-width">
                                <div class="label-small" v-if="!loading && !error">
                                    <h6>Labels:</h6>
                                    <div style="display: flex; gap: 10px;">
                                        <input class="form-control" type="text" placeholder="Enter label" v-model="label">
                                        <button class="btn btn-success" @click="addLabel()">Add</button>
                                    </div>
                                    <div style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); margin-top: 8px; gap: 8px;">
                                        <div v-for="label in labels" :key="label.index" style="width: 100%;">
                                            <span style="font-size: medium; width: 100%;">
                                                <b-badge style="width: 100%; display: flex; flex-direction: row; justify-content: space-between;" href="#" variant="dark">
                                                    <span style="width: 80%; padding: 4px; text-align: left;" @click="selectLabel(label.id)"> {{ label.name }} </span>
                                                    <span @click="deleteLabel(label.id)" style="width: 20%; padding: 4px;">🗙</span>
                                                </b-badge>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="label-small" v-else>
                                    <div class="loader-box">
                                        <div class="loader-10"></div>
                                    </div>
                                </div>

                                <div class="d-flex flex-wrap" style="gap: 12px; margin-top: 20px;">
                                    <div class="mini-box">
                                        <p class="mini-label">Total Leads</p>
                                        <h7 class="mini-value">{{ stats.total_leads }}</h7>
                                    </div>
                                    <div class="mini-box">
                                        <p class="mini-label">Qualified</p>
                                        <h7 class="mini-value">{{ stats.qualified }}</h7>
                                    </div>
                                    <div class="mini-box">
                                        <p class="mini-label">Pending Followup</p>
                                        <h7 class="mini-value">{{ stats.pending_followup }}</h7>
                                    </div>
                                    <div class="mini-box">
                                        <p class="mini-label">Hot Leads</p>
                                        <h7 class="mini-value">{{ stats.hot_leads }}</h7>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Container-fluid Ends-->

    <!-- Create Lead -->
    <b-modal id="modal-prevent-closing" size="lg" ref="modal" title="Create Lead" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="First Name" label-for="first-name-input" invalid-feedback="First name is required" :state="nameState">
                        <b-form-input id="first-name-input" v-model="item.first_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Last Name" label-for="last-name-input" invalid-feedback="Last name is required" :state="nameState">
                        <b-form-input id="last-name-input" v-model="item.last_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email" label-for="email-input" invalid-feedback="Email address is required" :state="nameState">
                        <b-form-input id="email-input" v-model="item.email" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Phone" label-for="phone-input" invalid-feedback="Phone number is required" :state="nameState">
                        <b-form-input id="phone-input" v-model="item.phone" :state="nameState"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Role" label-for="role-input" invalid-feedback="Role is required" :state="nameState">
                        <b-form-input id="role-input" v-model="item.role" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Company" label-for="company-name" invalid-feedback="Company is requited" :state="nameState">
                        <b-form-select id="company-name" v-model="item.company" :options="companyOptions" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Company
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Owner" label-for="owner-name" invalid-feedback="Owner is requited" :state="nameState">
                        <b-form-select id="owner-name" v-model="item.owner" :options="ownerOptions" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Owner
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Source" label-for="owner-name">
                        <b-form-select id="owner-name" v-model="item.source" :options="source_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Source
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Stage" label-for="stage-name" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="stage-name" v-model="item.stage" :options="stage_list" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Stage
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Status" label-for="status" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="status" v-model="item.status" :options="status_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Status
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Trigger Event" label-for="source-input">
                        <b-form-input id="source-input" v-model="item.trigger_event"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Pipeline Value" label-for="pipeline">
                        <b-form-input id="pipeline" type="number" min="0" v-model="item.pipeline_value"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Date">
                        <b-form-datepicker v-model="followupDate" />
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Time">
                        <b-form-timepicker v-model="followupTime" />
                    </b-form-group>
                </div>
            </div>

        </form>
    </b-modal>

    <!-- Edit Lead -->
    <b-modal id="modal-prevent-closing-edit" size="lg" ref="modal" title="Edit Lead"  @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="First Name" label-for="first-name-input" invalid-feedback="First name is required" :state="nameState">
                        <b-form-input id="first-name-input" v-model="edit_item.first_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Last Name" label-for="last-name-input" invalid-feedback="Last name is required" :state="nameState">
                        <b-form-input id="last-name-input" v-model="edit_item.last_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email" label-for="email-input" invalid-feedback="Email address is required" :state="nameState">
                        <b-form-input id="email-input" v-model="edit_item.email" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Phone" label-for="phone-input" invalid-feedback="Phone number is required" :state="nameState">
                        <b-form-input id="phone-input" v-model="edit_item.phone" :state="nameState"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Role" label-for="role-input" invalid-feedback="Role is required" :state="nameState">
                        <b-form-input id="role-input" v-model="edit_item.role" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Company" label-for="company-name" invalid-feedback="Company is requited" :state="nameState">
                        <b-form-select id="company-name" v-model="edit_item.company" :options="companyOptions" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Company
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Owner" label-for="owner-name" invalid-feedback="Owner is requited" :state="nameState">
                        <b-form-select id="owner-name" v-model="edit_item.owner" :options="ownerOptions" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Owner
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Source" label-for="owner-name">
                        <b-form-select id="owner-name" v-model="edit_item.source" :options="source_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Source
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Stage" label-for="stage-name" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="stage-name" v-model="edit_item.stage" :options="stage_list" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Stage
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Status" label-for="status" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="status" v-model="edit_item.status" :options="status_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Status
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Trigger Event" label-for="source-input">
                        <b-form-input id="source-input" v-model="edit_item.trigger_event"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Pipeline Value" label-for="pipeline">
                        <b-form-input id="pipeline" type="number" min="0" v-model="edit_item.pipeline_value"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Date">
                        <b-form-datepicker v-model="followupDate" />
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Time">
                        <b-form-timepicker v-model="followupTime" />
                    </b-form-group>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this lead?</div>
    </b-modal>

    <!-- Edit Lead -->
    <b-modal id="modal-prevent-closing-label" ref="modal" title="Add Label" @show="resetLabelModal" hide-footer @hidden="resetLabelModal" @ok="handleLabelOk">
        <h6>Labels</h6>

        <div class="row">
            <div class="text-center col-sm-6 w-full" v-for="label in this.already_assigned_labels" :key="label.id" v-b-tooltip.hover @click="deletetLeads(label.id)" title="Delete">
                <div class="w-100 mb-2 badge-style">
                    <h7>{{ label.name}}</h7>
                    <b-icon icon="x" style="color: white;"></b-icon>
                </div>
            </div>
        </div>

        <form ref="form" @submit.stop.prevent="handleLabelSubmit">
            <multiselect v-model="assignedLabels" tag-placeholder="Add member" placeholder="Search or add a label" label="name" :max="labels.length" track-by="id" :options="labels" :multiple="true" :taggable="true"></multiselect>
        </form>
    </b-modal>

    <!-- Status -->
    <b-modal id="modal-status-change" ref="modal" title="Update Lead Status" @show="resetStatusModal" @hidden="resetStatusModal" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="statusChange" :options="status_list"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
export default {
    components: {
        Multiselect,
        Datepicker
    },

    data() {
        return {
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Lead',
                    sortable: true
                },
                {
                    key: 'trigger',
                    label: 'Trigger',
                    sortable: true
                },
                {
                    key: 'stage',
                    label: 'Stage',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'owner',
                    label: 'Owner',
                    sortable: true
                },
                {
                    key: 'value',
                    label: 'Value',
                    sortable: true
                },
                {
                    key: 'next_followup',
                    label: 'Next Follow-up',
                    sortable: true
                },
                {
                    key: 'label',
                    label: 'Label',
                    sortable: true
                },
                // {
                //     key: 'contacted',
                //     label: 'Contacted',
                //     sortable: true
                // },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            item: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: null,
            },

            edit_item: {
                id: null,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: null,
                contacted: null,
            },
            followupDate: null,
            followupTime: '09:00:00',

            assignedLabels: [],

            label: '',
            selected: null,

            lead_id: null,
            already_assigned_labels: [],

            delete_value: null,

            filter: null,

            filterShow: false,
            selectConnected: '',
            selectedLabel: null,

            update_lead_id: null,

            connected_list: [{
                    id: 1,
                    name: 'Yes',
                    value: 'True'
                },
                {
                    id: 2,
                    name: 'No',
                    value: 'False'
                }
            ],
            stage_list: [{
                    value: 'suspect',
                    text: 'Suspect'
                },
                {
                    value: 'qualified',
                    text: 'Qualified'
                },
                {
                    value: 'discovery',
                    text: 'Discovery'
                },
                {
                    value: 'demo',
                    text: 'Demo'
                },
                {
                    value: 'proposal',
                    text: 'Proposal'
                },
                {
                    value: 'trial',
                    text: 'Trial'
                },
                {
                    value: 'customer',
                    text: 'Customer'
                }
            ],

            status_list: [{
                    value: 'open',
                    text: 'Open'
                },
                {
                    value: 'active',
                    text: 'Active'
                },
                {
                    value: 'hold',
                    text: 'Hold'
                },
                {
                    value: 'lost',
                    text: 'Lost'
                },
                {
                    value: 'rejected',
                    text: 'Rejected'
                },
                {
                    value: 'converted',
                    text: 'Converted'
                }
            ],

            source_list: [{
                    value: 'linkedin',
                    text: 'LinkedIn'
                },
                {
                    value: 'referral',
                    text: 'Referral'
                },
                {
                    value: 'website',
                    text: 'Website'
                },
                {
                    value: 'cold_outreach',
                    text: 'Cold Outreach'
                },
                {
                    value: 'event',
                    text: 'Event'
                },
                {
                    value: 'other',
                    text: 'Other'
                }
            ],
            closure_list:[
                {
                    value:'none',
                    text:'None',
                },
                {
                    value:'pending',
                    text:'Pending',
                },
                {
                    value:'approved',
                    text:'Approved',
                },
                {
                    value:'rejected',
                    text:'Rejected',
                }

            ],

            initialLoad: true,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            isModifyingDate: false,
            nameState: null,
            loadingPage: false,
            pageInput: 1,
            pageInputDebounce: null,

            selectedStage: null,
            selectedStatus: null,
            selectedOwner: null,
            selectedSource: null,
            selectedClosureStatus: null,
            statusChange:''

        };
    },

    computed: {
        ...mapState({
            items: state => state.lead.lead,
            loading: state => state.lead.submitLoading,
            error: state => state.lead.submitError,
            count: state => state.lead.lead_count,
            labels: state => state.lead.label,
            companies: state => state.client.company,
            salesReps: state => state.salesRep.salesRep,
            stats: state => state.lead.lead_stats,
        }),

        totalPages() {
            return Math.ceil(this.count / this.perPage);
        },

        formattedContact() {
            return [{
                    value: '',
                    text: 'Contacted',
                    disabled: true
                },
                {
                    value: true,
                    text: 'Yes'
                },
                {
                    value: false,
                    text: 'No'
                }
            ];
        },

        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select contact status',
                    disabled: true
                },
                ...this.connected_list.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },

        formattedLabels() {
            return [{
                    value: '',
                    text: 'Select Labels',
                    disabled: true
                },
                ...this.labels.map(status => ({
                    value: status.name,
                    text: status.name
                }))
            ];
        },
        companyOptions() {
            return this.companies.map(comm => ({
                value: comm.id,
                text: comm.name
            }));
        },

        ownerOptions() {
            return this.salesReps.map(rep => ({
                value: rep.id,
                text: rep ?.user ?.full_name || 'No Name'
            }));
        },

    },

    mounted() {
        this.$store.dispatch("client/fetchCompany");
        this.$store.dispatch("salesRep/fetchSalesRep")
        this.$store.dispatch("lead/fetchLabel");
        this.$store.dispatch("lead/fetchLeadStats");

        const query = this.$route.query;
        this.currentPage = parseInt(query.page) || 1;
        this.pageInput = this.currentPage;
        this.perPage = parseInt(query.perPage) || 25;

        if (query.category) {
            this.selectedCategory = query.category;
        }
        if (query.stage) {
            this.selectedStage = query.stage;
        }
        if (query.status) {
            this.selectedStatus = query.status;
        }
        if (query.owner) {
            this.selectedOwner = query.owner;
        }
        if (query.source) {
            this.selectedSource = query.source;
        }
        if (query.closure_status) {
            this.selectedClosureStatus = query.closure_status;
        }
            
        if (this.selectedLabel || this.selectedStage || this.selectedStatus || this.selectedOwner || this.selectedSource || this.selectedClosureStatus || this.filter) {
            this.filterShow = true;
        }

        this.updateRouteQuery();
        this.fetchInitialUpdate();

 
    },

    watch: {
        followupDate() {
            this.updateDateTime()
        },
        followupTime() {
            this.updateDateTime()
        },
        assignedLabels: {
            handler: function (newVal, oldVal) {
                this.storeAssignedLabels(newVal);
            },
            deep: true
        },


        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedLabel(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        currentPage(newVal, oldVal) {
            if (this.pageInput != newVal) {
                this.pageInput = newVal;
            }
            if (!this.loadingPage && !this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        perPage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },


        selectedStage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedStatus(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedOwner(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedSource(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedClosureStatus(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
    },

    methods: {
        updateRouteQuery() {
            const query = {
                page: this.currentPage,
                perPage: this.perPage
            };

            if (this.selectedLabel) {
                query.label = this.selectedLabel;
            }
            if (this.selectedStage ) {
                query.stage = this.selectedStage;
            }
            if (this.selectedStatus ) {
                query.status = this.selectedStatus;
            }
            if (this.selectedOwner ) {
                query.owner = this.selectedOwner;
            }
             if (this.selectedSource ) {
                query.source = this.selectedSource;
            }
            if(this.selectedClosureStatus){
                query.closure_status = this.selectedClosureStatus;
            }
            if (this.filter) {
                query.search_term = this.filter;
            }
          
            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        fetchInitialUpdate() {
            this.$store.dispatch("lead/fetchLead", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,


            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        fetchData() {
            if (!this.initialLoad) {
                this.$store.dispatch("lead/fetchLead", {
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    search_term: this.filter,
                    contacted: this.selectConnected,
                    label: this.selectedLabel,
                    stage: this.selectedStage,
                    status: this.selectedStatus,
                    owner: this.selectedOwner,
                    source: this.selectedSource,
                    closure_status: this.selectedClosureStatus,

                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        },
        formatDateTime(date) {
            return new Date(date).toLocaleString('en-BD', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        },
        updateDateTime() {
            if (this.followupDate && this.followupTime) {
                this.item.next_followup =
                    `${this.followupDate}T${this.followupTime}`
            }
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        handlePageInput() {

            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
            }

            if (!this.pageInput || this.pageInput === '') {
                return;
            }

            this.pageInputDebounce = setTimeout(() => {
                this.validatePage();
            }, 800);
        },

        validatePage() {
            this.loadingPage = true;

            // Clear debounce timer
            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
                this.pageInputDebounce = null;
            }

            const totalPages = this.totalPages;
            let page = parseInt(this.pageInput);

            if (!page || isNaN(page) || page < 1) {
                page = 1;
            } else if (page > totalPages) {
                page = totalPages;
            }

            this.pageInput = page;
            this.currentPage = page;

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
            this.pageInput = page; // Update input too
        },
        

        clearFilter() {
            this.filterShow = false,
            this.filter = null,
            this.selectedLabel = null,
            this.selectedStage = null,
            this.selectedStatus = null,
            this.selectedOwner = null,
            this.selectedSource = null,
            this.selectedClosureStatus = null,
            this.selectConnected = null
        },

        selectLabel(id) {
            this.selectedLabel = id
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        storeAssignedLabels(assignedLabels) {
            const latestId = assignedLabels[assignedLabels.length - 1].id;

            this.$store.dispatch("lead/addLabeltoLead", {
                lead: this.lead_id,
                label_id: latestId,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                labelAdd_delete: true,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedLabels = [];

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-label')
            })
        },

        addLabeltoLead(type) {
            this.lead_id = type.id
            this.already_assigned_labels = type.label
        },

        deletetLeads(id) {
            this.$store.dispatch("lead/deleteLabelfromLead", {
                leadId: this.lead_id,
                label_id: id,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                labelAdd_delete: true,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedLabels = [];

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-label')
            })
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        addLabel() {
            if (this.label !== '') {
                this.$store.dispatch("lead/addLabel", this.label).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.label = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        },

        resetModal() {

            this.item = {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: null,
            }
            this.followupDate = null,
                this.followupTime = '09:00:00'

        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleSubmit() {
            if (!this.checkFormValidity()) {
                return
            }

            this.$store.dispatch("lead/addLead", {
                item: this.item,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.resetModal()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })

        },

        editItem(item) {
            console.log(item)
            this.edit_item.id = item.id
            this.edit_item.first_name = item.first_name
            this.edit_item.last_name = item.last_name
            this.edit_item.email = item.email
            this.edit_item.phone = item.phone
            this.edit_item.role = item.role
            this.edit_item.company = item.company ? item.company.id : null
            this.edit_item.stage = item.stage
            this.edit_item.status = item.status
            this.edit_item.owner = item.owner ? item.owner.id : null
            this.edit_item.source = item.source
            this.edit_item.trigger_event = item.trigger_event
            this.edit_item.pipeline_value = item.pipeline_value

            if (item.next_followup) {
                const date = new Date(item.next_followup);
                this.followupDate = date.toISOString().split('T')[0];
                this.followupTime = date.toTimeString().split(' ')[0];
            }

        },

        resetEditModal() {
            this.edit_item = {
                id: null,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: '',
                contacted: null,
            }
            // this.followupDate = null,
            // this.followupTime = '09:00:00'
        },

        handleEditSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            if (this.edit_item.next_followup !== null) {
                this.edit_item.next_followup = moment(String(this.edit_item.next_followup)).format("YYYY-MM-DD");
            }
            this.$store.dispatch("lead/updateLead", {
                item: this.edit_item,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })

        },

        deleteLead(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("lead/deleteLead", {
                item: this.delete_value,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deleteLabel(id) {
            this.$store.dispatch("lead/deleteLabel", id).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },
        // resetStatusModal(){
        //     this.update_lead_id = null
        // },

        getStatus(status, id) {
            this.update_lead_id = id
            this.statusChange = status
        },

        handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleStatusSubmit()
        },

        handleStatusSubmit() {
            this.$store.dispatch("lead/updateLeadStatus", {
                id: this.update_lead_id,
                status_for_change: this.statusChange,
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
             

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.statusChange = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-status-change')
            })
        },
    }
};
</script>

<style scoped>
.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.lead-container {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.table-width {
    width: 100%;
}

.label-width {
    width: 100%;
}

.label-small {
    width: 100%;
}

@media screen and (min-width: 768px) {
    .label-small {
        width: 65%;
    }
}

@media screen and (min-width: 1100px) {
    .label-small {
        width: 50%;
    }
}

@media screen and (min-width: 1536px) {
    .lead-container {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .table-width {
        width: 75%;
    }

    .label-width {
        width: 25%;
    }

    .label-small {
        width: 100%;
    }
}

.mini-box {
    flex: 0 0 170px;
    width: 170px;
    padding: 16px 24px;
    border-radius: 8px;
    transition: 0.3s ease;
    background-color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

}

.mini-box:hover {
    transform: translateY(-3px);
}

.mini-label {
    font-size: 14px;
    font-weight: 600;
    color: #62748e;
}

.mini-value {
    font-size: 18px;
    font-weight: 700;

}

/* Stage */
.stage-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 600;
}

/* Stages */
.stage-suspect {
    background: #f3f4f6;
    color: #6b7280;
   
}

.stage-qualified {
    background: #dbeafe;
    color: #2563eb;
}

.stage-discovery {
    background: #ede9fe;
    color: #7c3aed;
}

.stage-demo {
    background: #cffafe;
    color: #0891b2;
}

.stage-proposal {
    background: #fef3c7;
    color: #d97706;
}

.stage-trial {
    background: #fee2e2;
    color: #dc2626;
}

.stage-customer {
    background: #dcfce7;
    color: #16a34a;
}
</style>
